/*
 * 一元夺宝
 * */
import request from "@utils/request";

/**
 * 获取商品列表
 * @returns {*}
 */
export function getList(data) {
  return request.get("/one_win",data);
}


/**
 * 订单列表
 * @returns {*}
 */
export function getOrder(data) {
    return request.get("/one_win/my_order",data);
}


/**
 * 历史列表
 * @returns {*}
 */
export function getAward(data) {
    return request.get("/one_win/award",data);
}



/**
 * 下注接口
 * @param {num,game_id} 下单数量，商品id
 * @returns {*}
 */
export function saveOrder(data) {
    return request.post("/one_win/create", data);
}
